'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGES = exports.MESSAGES = ['messages'];
var START_TIMESTAMP = exports.START_TIMESTAMP = ['startTimestamp'];
var END_TIMESTAMP = exports.END_TIMESTAMP = ['endTimestamp'];
var VISITOR_LAST_READ_AT_TIMESTAMP = exports.VISITOR_LAST_READ_AT_TIMESTAMP = ['visitorLastReadAtTimestamp'];
var NUM_SOFT_DELETED_MESSAGES = exports.NUM_SOFT_DELETED_MESSAGES = ['numSoftDeletedMessages'];